import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    position: 'relative',
    backgroundColor: $theme.colors.white,

    [$theme.mediaQuery.large]: {
        width: '560px',
        paddingBottom: '1.6rem'
    }
}))

export const Title = styled('h2', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 700,
    color: '#000',
    marginTop: 0,
    marginBottom: '0.8rem'
}))

export const LotsSectionWrapper = styled('div', ({ $theme }) => ({
    padding: '0 1.6rem'
}))

export const SearchContainer = styled('div', ({ $theme }) => ({
    marginTop: '2rem',
    height: 'fit-content',
    padding: '0 1.6rem'
}))

export const ViewContainer = styled('div', ({ $theme }) => ({
    marginTop: '2rem'
}))

export const ToggleIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.white,
    fontSize: '1.6rem'
}))

export const ToggleText = styled('span', ({ $theme }) => ({
    color: $theme.colors.white,
    ...$theme.typography.LabelSmall,
    fontWeight: 700
}))
